import React, { FC } from "react";

import { SkillEvaluationStandardSummaryCategoryType } from "~/domains";

import { CatchTitleBorder, LinkTitleItem } from "~/ui";
import { InfiniteScrollWithMoreButton } from "~/ui";

type PropsType = {
  title: string;
  skillEvaluationStandardSummaryCategories: SkillEvaluationStandardSummaryCategoryType[];
  fetchNextPage: () => void;
  hasMore?: boolean;
  className?: string;
  businessSectionId?: string;
};

export const SkillEvaluationStandardSummaryCategoryTitleInfinitiesScroll: FC<
  PropsType
> = ({
  title,
  skillEvaluationStandardSummaryCategories,
  hasMore,
  className = "",
  businessSectionId = "",
  fetchNextPage,
}: PropsType) => {
  return (
    <div className={className}>
      <CatchTitleBorder text={title} />
      <InfiniteScrollWithMoreButton
        itemsLength={skillEvaluationStandardSummaryCategories.length}
        nextFetchFunction={fetchNextPage}
        hasMore={hasMore}
        className="mt-6"
        scrollClassName="space-y-6"
      >
        {skillEvaluationStandardSummaryCategories.map((item) => (
          <LinkTitleItem
            key={item.id}
            to={`/skill_evaluation_standard_summary_categories/${item.id}?business_section_id=${businessSectionId}`}
            title={item.name}
          />
        ))}
      </InfiniteScrollWithMoreButton>
    </div>
  );
};
